
	import { defineComponent } from 'vue';
	import { templateLibraryComposition } from '../services';
	
	// Components
	import TemplateArea from './builder/template-area.vue';

	export default defineComponent ({
		name: 'core-template-library',
		components: {
			TemplateArea,
		},
		setup () {
			return { ...templateLibraryComposition() }
		}
	})
